import UseCasesIcon from '@icons/UseCasesIcon.svg';
import RetentionIcon from '@icons/RetentionIcon.svg';
import TrendingIcon from '@icons/trend.svg';
import EfficiencyIcon from '@icons/EfficientIcon.svg';
import type { UseCasesWhyHowBlock } from '@components/widgets';

export const GENERAL_AGENTS_USE_CASES_WHY_HOW_SECTION_TITLE =
    'Why Predictable Benefits for General Agents';

export const GENERAL_AGENTS_USE_CASES_WHY_HOW_BLOCKS: UseCasesWhyHowBlock[] =
    [
        {
            pillNavLabel: 'New Market',
            title: 'Reclaiming the "First-Time Buyer" Market',
            description:
                'Statistically, over 80% of employers adopting ICHRA are new to offering benefits. Historically, GAs focused on moving existing group business.',
            cards: [
                {
                    iconSrc: UseCasesIcon,
                    title: 'The Use Case',
                    description:
                        'GAs can provide their brokers with a "Small Business Growth Kit"—a white-labeled ICHRA portal that allows brokers to efficiently quote and enroll micro-groups (1–20 lives) that were previously too small for the GA to service profitably.',
                },
                {
                    iconSrc: TrendingIcon,
                    title: 'Growth Impact',
                    description:
                        'Dramatically expands the GA’s total addressable market (TAM) to include the millions of uninsured small businesses.',
                },
            ],
        },
        {
            pillNavLabel: 'Broker Retention',
            title: 'Defending Against "Direct-to-Broker" Turnkey Platforms',
            description:
                'ICHRA Startup platforms are actively pitching your brokers, promising ease of use but often charging high PEPM fees or siphoning off the broker relationship.',
            cards: [
                {
                    iconSrc: UseCasesIcon,
                    title: 'The Use Case',
                    description:
                        'The GA equips brokers with a white-labeled ICHRA platform so they can quote, present, and enroll clients without leaving the GA ecosystem. That keeps the broker relationship in-house while giving brokers the technology they need to compete.',
                },
                {
                    iconSrc: RetentionIcon,
                    title: 'Retention Impact',
                    description:
                        'The broker doesnt need to go to a third-party startup. They get the same (or better) tech from the GA they already trust, allowing the GA to keep the "stickiness" of the broker’s entire book of business.',
                },
            ],
        },
        {
            pillNavLabel: 'Unified Quoting',
            title: 'Multi-Carrier "All-In-One" Quoting',
            description:
                'Brokers hate having to go to 10 different carrier portals for individual quotes.',
            cards: [
                {
                    iconSrc: UseCasesIcon,
                    title: 'The Use Case',
                    description:
                        'The Predictable Benefits platform aggregates all individual market carriers into one view.',
                },
                {
                    iconSrc: EfficiencyIcon,
                    title: 'Efficiency Impact',
                    description:
                        'The GA becomes the single source of truth for "Group vs. ICHRA" comparisons. Brokers will flood to the GA that makes the analysis the easiest to perform.',
                },
            ],
        },
    ];
